import { mergeStyles, Stack } from "@fluentui/react";
import { BreakpointType } from "../ContainerFluid";
import { useScreenViewportByBreakpoint } from "../ContainerStyles";
import React from "react";

export interface IColProps {
    colClass?: string;
}

export const Col: React.FC<IColProps> = (props) => {
    const breakpoint = useScreenViewportByBreakpoint();

    const colClass = mergeStyles({
        gridColumn: `auto/span 1`,
        justifyContent: 'center',
        justifyItems: 'top',
        textAlign: 'center',
        ...(breakpoint === BreakpointType.sm && { gridColumn: 'auto/span 12' }),
        ...(breakpoint === BreakpointType.md && { gridColumn: 'auto/span 12' }),
        ...(breakpoint === BreakpointType.lg && { gridColumn: 'auto/span 6' }),
        ...(breakpoint === BreakpointType.xl && { gridColumn: 'auto/span 6' }),
        ...(breakpoint === BreakpointType.xxl && { gridColumn: 'auto/span 6' }),
        ...(breakpoint === BreakpointType.xxxl && { gridColumn: 'auto/span 6' }),
    });

  
    return (
        <Stack
            className={props.colClass ? props.colClass : colClass}
        >
            {props.children}
        </Stack>
    );
}


export const col1 = mergeStyles([{
    gridColumn: 'auto/span 1'
}]);

export const col2 = mergeStyles([{
    gridColumn: 'auto/span 2'
}]);

export const col3 = mergeStyles([{
    gridColumn: 'auto/span 3'
}]);

export const col4 = mergeStyles([{
    gridColumn: 'auto/span 4'
}]);

export const col5 = mergeStyles([{
    gridColumn: 'auto/span 5'
}]);

export const col6 = mergeStyles([{
    gridColumn: 'auto/span 6'
}]);

export const col7 = mergeStyles([{
    gridColumn: 'auto/span 7'
}]);

export const col8 = mergeStyles([{
    gridColumn: 'auto/span 8'
}]);

export const col9 = mergeStyles([{
    gridColumn: 'auto/span 9'
}]);

export const col10 = mergeStyles([{
    gridColumn: 'auto/span 10'
}]);

export const col11 = mergeStyles([{
    gridColumn: 'auto/span 11'
}]);

export const col12 = mergeStyles([{
    gridColumn: 'auto/span 12'
}]);